import { useQuery } from '@tanstack/react-query';
import { getInvestmentAccountRequest } from 'services/secondary';

const useGetInvestmentAccount = ({ primaryUserId }) => {
  const { data, error, isLoading, isError, refetch } = useQuery({
    queryKey: ['investmentAccount', primaryUserId],
    queryFn: () => getInvestmentAccountRequest({ primaryUserId }),
    enabled: !!primaryUserId,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });

  return {
    data,
    error,
    isLoading,
    isError,
    refetch,
  };
};

export default useGetInvestmentAccount;
